<template>
    <div>
        <div v-if="show">

            <div v-if="plan_config&&unit_list&&plan_config_loaded" class="plan-content">
                <v-card flat v-if="display_option.show_title" class="my-5">
                    <div class="plan-title row d-flex pa-2">
                        <div class="col-12 col-sm-6 py-0 plan-logo">

                            <v-img
                                    v-if="plan_config.ImagePath.indexOf('http') == -1"
                                    alt="plan logo"
                                    :src="'http://rmis.lpn.co.th/modules/sale_plan/assets/images/'+plan_config.ImagePath"
                                    max-height="100"
                                    contain
                            />
                            <v-img
                                    v-else
                                    alt="plan logo"
                                    :src="plan_config.ImagePath"
                                    :lazy-src="plan_config.ImagePath"
                                    max-height="100"
                                    contain
                            >
                                <template v-slot:placeholder>
                                    <v-row
                                            class="fill-height ma-0"
                                            align="center"
                                            justify="center"
                                    >
                                        <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                                    </v-row>
                                </template>
                            </v-img>
                        </div>
                        <div class="col-12 col-sm-6 plan-name d-flex align-center justify-center flex-fill">
                            <h3>{{ plan_config.pj_name }}</h3>
                        </div>
                    </div>
                </v-card>

                <div v-if="building_config&&room_direction" class="plan-table-div">

                    <v-card flat class="my-5">
                        <v-card-text>
                            <label class="blue--text">คำอธิบาย</label>
                            <p class="mt-2 mb-0">ขนาดห้อง</p>
                            <v-row class="row--dense">
                                <v-col v-for="(desc, desc_index) in size_color"
                                       :key="'desc_'+desc_index"
                                       class="col text-center"
                                       :style="'background:'+desc[0]+';border:1px solid #f0f0f0;'"
                                >
                                    {{ desc[1] }}
                                </v-col>
                            </v-row>
                            <p v-if="isEvent('PreSale')" class="mt-2 mb-0">ระดับความสนใจ</p>
                            <v-row v-if="isEvent('PreSale')" class="row--dense">
                                <v-col v-for="(hot, hot_index) in hot_color"
                                       :key="'hot_'+hot_index"
                                       class="col text-center"
                                       :style="'background:'+hot.color_code+';border:1px solid #f0f0f0;color:'+hot.color_text+';'"
                                >
                                    {{ hot.order }}
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>

                    <v-card flat class="my-5">
                        <v-card-text>
                            <label class="blue--text">ตั้งค่าการแสดงผล</label>
                            <v-row>
                                <v-col v-if="isEvent('StaffGetMember')" cols="12" class="py-0">
                                    <v-select
                                            v-model="selected_building"
                                            :items="building_config"
                                            label="เลือกอาคาร"
                                            item-text="bd_name"
                                            return-object
                                            menu-props="auto"
                                            @change="hideBlank=false"
                                            flat
                                            ref="select_building"
                                    >
                                        <v-list-item
                                                slot="prepend-item"
                                                @click="selectAll()"
                                        >
                                            <v-list-item-content>
                                                ทั้งหมด
                                            </v-list-item-content>
                                        </v-list-item>
                                        <v-divider
                                                slot="prepend-item"
                                                class="mt-0"
                                        />
                                    </v-select>
                                    <v-btn x-small @click="selectAll()" class="mt-n3 float-right">แสดงทั้งหมด</v-btn>
                                </v-col>
<!--                                <v-col v-else-if="isEvent('PreSale')" cols="12" class="py-0">-->
                                <v-col v-else cols="12" class="py-0">
                                    <p class="mt-2 mb-0">เลือกอาคาร</p>
                                    <v-row class="row--dense">
                                        <template v-for="(bd, bd_index) in building_config">
                                            <v-col v-if="bd_index==0" class="col text-center ma-1 select_building"
                                                   @click="setSelectBuildingAll()"
                                                   :style="'background:#ccc;'+(!selected_building ? 'background:#16448f !important;color:#fff;':'')"
                                            >
                                                ทั้งหมด
                                            </v-col>
                                            <v-col class="col text-center ma-1 select_building"
                                                   @click="setSelectedBuilding(bd)"
                                                   :style="'background:#ccc;'+(selected_building&&bd.bd_runno==selected_building.bd_runno ? 'background:#16448f !important;color:#fff;':'')"
                                            >
                                                {{ bd.bd_name }}
                                            </v-col>
                                        </template>
                                    </v-row>
                                </v-col>
                                <v-col cols="12" class="py-0">
                                    <v-switch v-model="hideBlank" @change="hideBlankFloor()" label="แสดงเฉพาะชั้นที่มียูนิต"></v-switch>
                                </v-col>
                                <v-col cols="12" class="py-0">
                                    <v-slider
                                            v-model="planStyle_zoom"
                                            append-icon="mdi-magnify-plus-outline"
                                            prepend-icon="mdi-magnify-minus-outline"
                                            min="0.2"
                                            max="2"
                                            step="0.01"
                                            @click:append="zoomIn"
                                            @click:prepend="zoomOut"
                                            class="zoom_tool"
                                            :style="toolStyle"
                                    ></v-slider>
                                </v-col>
        <!--                    <v-btn class="float-right" @click="renderPlanAsImage('plan_all')">แสดงภาพรวม</v-btn>-->
                            </v-row>
                        </v-card-text>
                    </v-card>

                    <div id="plan_all" class="plan_all mt-5">
                        <div v-for="(bc, bc_index) in building_config"
                             :key="'building_'+bc_index"
                             class="plan-building-list mt-3"
                        >
                            <template v-if="!selected_building||(selected_building.bd_name==bc.bd_name)">
                                <h3 class="plan-building-name">
                                    อาคาร {{ bc.bd_name }}
                                </h3>
                                <div :class="'plan-table-detail mx-n3 mx-md-0'+(onRenderCanvas ? 'on-canvas':'')" :style="planStyle">
                                    <table class="plan-table mt-2">

                                            <tr>
                                                <td class="bd-no pl-3 pr-3" rowspan="2">{{ bc.bd_name }}</td>
                                                <td v-for="(direction, direction_index) in roomDirectionFilter(bc.bd_runno)"
                                                    :key="'direction_'+direction_index"
                                                    class="direction text-center" :colspan="direction.direction_width"
                                                >
                                                    {{ getDirectionName(direction.direction_code) }}
                                                </td>
                                            </tr>

                                            <template v-for="(fl, fl_index) in parseInt(bc.max_floor)">

                                                <tr v-if="((parseInt(bc.max_floor)-fl)+1)==parseInt(bc.max_floor)">
                                                    <template
                                                        v-for="(room, room_index) in getRoomLabel(bc,roomDirectionFilter(bc.bd_runno))"
                                                    >
                                                        <td v-if="room.hasOwnProperty('name')" class="room-no with_direction" :rowspan="room.rowspan" v-html="room.name"></td>
                                                        <td v-else class="room-no" :style="tdWidthStyle+tdHeightStyle">
                                                            {{ room }}
                                                        </td>
                                                    </template>
                                                </tr>

                                                <tr v-if="(!JSON.parse(bc.floor_skip)||!(JSON.parse(bc.floor_skip).hasOwnProperty((parseInt(bc.max_floor)-fl)+1)&&JSON.parse(bc.floor_skip)[(parseInt(bc.max_floor)-fl)+1]))&&(parseInt(bc.floor_start)<=((parseInt(bc.max_floor)-fl)+1))">
                                                    <td v-if="((parseInt(bc.max_floor)-fl)+1)<=parseInt(bc.max_floor)" class="floor-no" :style="tdHeightStyle">
                                                        <div class="text-center" style="font-size: 1em;">
                                                            ชั้น
                                                            <span v-if="((parseInt(bc.max_floor)-fl)+1)!=13">
                                                                {{ ((parseInt(bc.max_floor)-fl)+1)>9 ? ((parseInt(bc.max_floor)-fl)+1):"0"+((parseInt(bc.max_floor)-fl)+1) }}
                                                            </span>
                                                            <span v-else>
                                                                12A
                                                            </span>
                                                        </div>
                                                    </td>
                                                    <template v-if="(((parseInt(bc.max_floor)-fl)+1)<=parseInt(bc.max_floor))">
                                                        <template v-for="(unit_data, unit_index) in getUnit(bc,((parseInt(bc.max_floor)-fl)+1),roomDirectionFilter(bc.bd_runno))">

                                                            <!-- hard code for LP-RM3RR -->
                                                            <td v-if="((parseInt(bc.max_floor)-fl))==26&&unit_index==14&&project_code=='C1001'" rowspan="22" class="no-room"></td>

                                                            <td :class="'unit '+(unit_data.hasOwnProperty('PD_RUNNO') ? 'has_unit':'no_unit')" @click="showDetail(unit_data)"
                                                                :style="'background-color:'+getColor(unit_data.hasOwnProperty('PD_RUNNO') ? unit_data.property_area:false)+';'+tdWidthStyle+tdHeightStyle+(unit_data.is_favorite&&unit_data.is_favorite=='Y' ? 'border: 1px solid #2196f3 !important;':'')"
                                                            >
                                                                <template v-if="unit_data.hasOwnProperty('PD_RUNNO')">
                                                                    <div v-if="!unit_data.available_status" class="d-flex fill-height unit_lock"></div>
                                                                    <div
                                                                            class="d-flex flex-column fill-height"
                                                                    >
                                                                        <div class="unit_code" :style="'background-color: '+unit_data.hot_color+';color:'+unit_data.hot_text+';'">
                                                                            <v-icon small v-if="unit_data.is_favorite&&unit_data.is_favorite=='Y'" color="blue" style="float:left;">
                                                                                mdi-star
                                                                            </v-icon>
                                                                            {{ unit_data.PD_CODE }}
                                                                        </div>
                                                                        <div
                                                                                v-if="display_option.display_field.divide&&(parseFloat(unit_data.price_total_amount)>0&&(unit_data.hasOwnProperty('property_is_open_for_sale')&&unit_data.property_is_open_for_sale=='Y'))"
                                                                                class="unit_value d-flex fill-height justify-center align-center"
                                                                        >
                                                                            {{ display_option.display_field.hasOwnProperty('format') ? reFormatNumber((unit_data[display_option.display_field.field_name])/(display_option.display_field.divide!=0 ? display_option.display_field.divide:1),display_option.display_field.format):unit_data[display_option.display_field.field_name] }}
                                                                        </div>
                                                                        <div
                                                                                v-else
                                                                                class="unit_value fill-height d-flex fill-height justify-center align-center"
                                                                        >
                                                                            {{ display_option.display_field.hasOwnProperty('format') ? reFormatNumber((unit_data[display_option.display_field.field_name]),display_option.display_field.format):unit_data[display_option.display_field.field_name] }}
                                                                        </div>
                                                                    </div>
                                                                </template>
                                                            </td>
                                                        </template>
                                                    </template>
                                                </tr>
                                            </template>
                                    </table>
                                </div>
                            </template>
                        </div>
                    </div>
                </div>
                <div class="plan_footer"></div>

                <v-overlay v-if="overall_image" :value="overlay2" :opacity="0.8">
                    <div @click="overlay2=false" class="close_fullcsreen_slide" style="position: absolute;right:10px;z-index: 9999;top:-30px;">
                        Close<v-icon right>mdi-close</v-icon>
                    </div>
                    <div class="text-center" id="overall_plan">
                        <v-img :src="overall_image" style="max-width: 100%;max-height: 90vh;"/>
                    </div>
                </v-overlay>

            </div>
        </div>
    </div>
</template>

<script>

    import numeral from 'numeral'
    import _ from 'lodash'

    export default {
        name: "CondoPlan",
        components:{
        },
        props: {
            show: {type: Boolean, default: false},
            project_code: {type: String, default: ''},
            project_id: {type: String, default: ''},
            plan_type: {type: String, default: 'sale_stock'},
            unit: {type: Array, default: []},
            updated_unit: {type: Object, default: null},
            option:{type: Object, default: null}
        },
        data() {
            return {
                current_loading_state:{
                    show:false,
                    message:'กำลังโหลดข้อมูล....กรุณารอสักครู่.',
                    progressColor:'blue'
                },
                plan_config_loaded:false,
                onRenderCanvas:false,
                plan_config:null,
                building_config:null,
                size_color:null,
                room_direction:null,
                unit_list:null,
                hideBlank:false,
                overlay2: false,
                overall_image:'',
                selected_building:null,
                hot_color: [
                    {
                        order:1,
                        score:0,
                        color_code:"#e7f5ae",
                        color_text:"#000",
                    },
                    {
                        order:2,
                        score:9999,
                        color_code:"#fee4a3",
                        color_text:"#000",
                    },
                    {
                        order:3,
                        score:9999,
                        color_code:"#fdb16c",
                        color_text:"#000",
                    },
                    {
                        order:4,
                        score:9999,
                        color_code:"#ee7a48",
                        color_text:"#fff",
                    },
                    {
                        order:5,
                        score:9999,
                        color_code:"#dd472f",
                        color_text:"#fff",
                    },
                    {
                        order:6,
                        score:9999,
                        color_code:"#e80003",
                        color_text:"#fff",
                    }
                ],
                score_list:null,
                display_option:{
                    display_field:{
                        field_name:'PD_CODE',
                    },
                    show_lock:true,
                    show_title:true,
                    style:{
                        td_width:"50px",
                        td_height:"60px",
                    },
                },
                planStyle_zoom:1,
                planZoomToolBottom:110,
            }
        },
        watch: {
            async project_code(){
                this.plan_config = await this.getPlanSetting()
                if(this.plan_config) {
                    this.building_config = await this.getBuildingSetting()
                    if(this.building_config&&this.building_config.length>0) {
                        this.selected_building = this.building_config[0]
                        this.room_direction = await this.getDirectionSetting()
                        this.size_color = JSON.parse(this.building_config[0].SizeColor)
                    }
                }
                if(this.unit&&this.unit.length>0){
                    this.unit_list = [...await this.mappingUnitData(this.unit)]
                }
                // else {
                //     this.unit_list = await this.getRmsUnitByProjectCode()
                // }
            },
            async updated_unit(v){
                // console.log("plan updated",v)
                if(v){
                    let tmp = []
                    await this.unit_list.forEach((data,key) =>{
                        if(data.property_id==v.property_id){
                            if(v.hasOwnProperty('is_favorite')){
                                data.is_favorite = v.is_favorite
                            }
                        }
                        tmp.push(data)
                    })
                    this.unit_list = [...tmp]
                }
            },
            async selected_building(){
                // console.log("bd")
                if(this.selected_floor) {
                    // this.plan_mapping = null
                    if (this.unit && this.unit.length > 0) {
                        this.unit_list = [...await this.mappingUnitData(this.unit)]
                    }
                }
            },
            overlay2(val) {
                if (val) {
                    document.addEventListener('mousedown', this.mousedownHandler)
                } else {
                    document.removeEventListener('mousedown', this.mousedownHandler)
                }
            }
        },
        destroyed () {
            window.removeEventListener('scroll', this.pageScrollHandler)
        },
        async mounted(){
            this.plan_config = await this.getPlanSetting()
            if(this.plan_config) {
                this.building_config = await this.getBuildingSetting()
                if(this.building_config&&this.building_config.length>0) {
                    this.selected_building = this.building_config[0]
                    this.room_direction = await this.getDirectionSetting()
                    this.size_color = JSON.parse(this.building_config[0].SizeColor)
                }
            }
            if(this.unit&&this.unit.length>0){
                this.unit_list = [...await this.mappingUnitData(this.unit)]
                // console.log(this.unit.length)
            }

            // console.log(this.unit_list)

            if(this.option){
                this.display_option = this.option
            }

            this.$nextTick(() => {
                this.plan_config_loaded = true
            })


            //load htmlcanvas
            // if (document.getElementById('html2canvas')) return; // was already loaded
            // let scriptTag = document.createElement("script");
            // scriptTag.src = "https://html2canvas.hertzen.com/dist/html2canvas.min.js";
            // scriptTag.id = "html2canvas";
            // document.getElementsByTagName('head')[0].appendChild(scriptTag);
        },
        async created() {
            window.addEventListener('scroll', this.pageScrollHandler)
        },
        computed: {
            planStyle () {
                return {
                    '--zoom-amount': this.planStyle_zoom
                }
            },
            toolStyle () {
                return {
                    '--bottom-zoom-tool': this.planZoomToolBottom+'px'
                }
            },
            tdWidthStyle () {
                // return "min-width: "+this.display_option.style.td_width+" !important;width: "+this.display_option.style.td_width+" !important;"
                return ""
            },
            tdHeightStyle () {
                // return "height:"+this.display_option.style.td_height+" !important;"
                return ""
            },
        },
        methods:{
            mousedownHandler(e) {
                if (e.target.classList.contains('v-overlay__scrim')){
                    this.overlay2 = false
                }
            },
            checkScoreUnit(property_id){
                if(this.score_list.length>0) {
                    let score = Object.entries(this.score_list).find(t =>
                        t[1].property_id === property_id
                    )
                    if(typeof(score) !== 'undefined' && score !== null){
                        // let summary = JSON.parse(JSON.stringify(score[1])).score_summary
                        let summary = JSON.parse(JSON.stringify(score[1])).rank
                        return summary
                    }
                }
                return 0
            },
            async mappingUnitData(ul){
                let temp_properties_list = []
                let tmp_mapping_unit = {}
                let fv = null

                this.score_list = await this.getPropertyScoreList()

                fv = await this.getFavoriteDetail()

                if(ul&&ul.length>0) {
                    ul.forEach(async (data, key) => {
                        // data.hit_score = this.checkScoreUnit(data.property_id)
                        data.score_range = this.checkScoreUnit(data.property_id)

                        // tmp_hot_color = this.hot_color.find((c)=>{
                        //     return c.score >= data.hit_score
                        // })
                        // data.hot_color = tmp_hot_color ? tmp_hot_color.color_code:this.hot_color[5].color_code
                        // data.hot_text = tmp_hot_color ? tmp_hot_color.color_text:this.hot_color[5].color_text
                        data.hot_color = data.score_range ? this.hot_color[parseInt(data.score_range)-1].color_code:this.hot_color[0].color_code
                        data.hot_text = data.score_range ? this.hot_color[parseInt(data.score_range)-1].color_text:this.hot_color[0].color_text

                        if (fv.length > 0) {
                            let found_fv = fv.find(t =>
                                t.property_id === data.property_id
                            )
                            if(found_fv){
                                data.is_favorite = 'Y'
                            }else{
                                data.is_favorite = 'N'
                            }
                        }else{
                            data.is_favorite = 'N'
                        }
                        temp_properties_list.push(data)

                    })
                }

                return temp_properties_list
            },
            async getPropertyScoreList(){
                const requestBody = {
                    project_id:this.project_id,
                    user_id:this.getAppUserId(),
                    type:1
                }
                let promiseChecking, finalResult = []

                promiseChecking = await this.promiseHandle(this.PostHttp('Readytomove/getPropertyScoreList', requestBody,false,'json','rms'))

                if (!promiseChecking.error) {
                    if (promiseChecking.result.status=='success'&&promiseChecking.result.res.data.code == '000') {
                        finalResult = [...promiseChecking.result.res.data.result]
                    }
                }

                return finalResult
            },
            getColor(area){
                let result_color = '#ffffff'
                if(area){
                    let area_multiply = area * 100
                    let area_compare = 0
                    let loopstop = false
                    if(this.size_color){
                        Object.entries(this.size_color).reverse().forEach((data, key) => {
                            area_compare = parseFloat(data[0])
                            if(area_multiply>=area_compare&&!loopstop){
                                result_color = data[1][0]
                                loopstop = true
                                // console.log(result_color)
                            }
                        });
                    }
                }
                return result_color
            },
            pageScrollHandler(e) {
                if (e){
                    let cc = this.$el.querySelector('.zoom_tool')
                    let base_elem = this.$el.querySelector('.plan_all')
                    if(base_elem) {
                        let base_position = base_elem.getBoundingClientRect()
                        if (base_position) {
                            if (base_position.top-80 < 52) {
                                cc.classList.add('float_zoom_tool','elevation-10');
                            } else {
                                cc.classList.remove('float_zoom_tool','elevation-10');
                            }
                        }

                    }
                }
            },
            zoomOut () {
                this.planStyle_zoom = (this.planStyle_zoom - 0.1) || 0.2
            },
            zoomIn () {
                this.planStyle_zoom = (this.planStyle_zoom + 0.1) || 1
            },
            async setSelectedBuilding(bd){
                if(bd) {
                    this.selected_building = bd
                }else{
                    this.selected_building = null
                }
            },
            setSelectBuildingAll(){
                this.selected_building = null
                this.hideBlank=false
                this.hideBlankFloor()
            },
            selectAll(){
                this.selected_building = null
                this.$refs.select_building.blur()
                this.hideBlank=false
                this.hideBlankFloor()
            },
            showDetail(unit_data){
                if(unit_data&&unit_data.hasOwnProperty('PD_RUNNO')) {
                    // console.log(unit_data)
                    this.$emit('togglePlanDetailDialog', {show:true,unit_data:unit_data});
                }
            },
            reFormatNumber(value,format){
                return value&&value!=0 ? numeral(value).format(format):''
            },
            getRoomLabel(bc,d){
                let start_room     = parseInt(bc.room_start)
                let max_room       = parseInt(bc.max_room_per_floor)
                let result = []
                let running = 0
                let non_block = {}

                let bef = 0
                let desc_run = 0
                for (let i = 1; i <= max_room; i++) {
                    if (bc.room_align == 'DESC') {
                        if (i > start_room) {
                            if(bef==start_room){
                                desc_run = max_room
                                result.push(desc_run<10 ? '0'+desc_run:desc_run)
                            }else{
                                result.push(desc_run<10 ? '0'+desc_run:desc_run)
                            }
                            bef = 0
                            desc_run--
                        } else {
                            result.unshift(i<10 ? '0'+i:i)
                            bef++
                        }
                    } else {
                        if (i >= start_room) {
                            if (i == start_room) {
                                result.unshift(i < 10 ? '0' + i : i)
                            }else{
                                bef++
                                result.splice(bef, 0, (i < 10 ? '0' + i : i))
                                result.join()
                            }
                        } else {
                            result.push(i<10 ? '0'+i:i)
                        }
                    }
                }

                for (let j = 0; j < d.length; j++) {
                    non_block = {...JSON.parse(d[j].non_block)}
                    let spacial_block = {}
                    let spacial_block_name = ''
                    let rowspan = parseInt(bc.max_floor)-parseInt(bc.floor_start)+2
                    for (let i = 1; i <= d[j].direction_width; i++) {
                        spacial_block = {}
                        spacial_block_name = ''
                        // console.log(result[i-1])
                        if(non_block&&non_block.hasOwnProperty(i) ){
                            spacial_block_name = non_block[i].toString()

                            if(spacial_block_name.split(":")[1]){
                                rowspan = parseInt(spacial_block_name.split(":")[1])
                            }

                            if(spacial_block_name.includes('ele')){
                                spacial_block_name = 'โถง<br>ลิฟต์<br>และ<br>บัน<br>ได'
                            }else if(spacial_block_name.includes('fire')){
                                spacial_block_name = 'บัน<br>ได<br>หนี<br>ไฟ'
                            }
                            spacial_block = {
                                name:spacial_block_name,
                                rowspan:rowspan
                            }
                            result.splice(running, 0, spacial_block)
                            result.join()
                        }
                        running++
                    }
                }

                // console.log(result)
                return result
            },
            getUnit(bc,fl){
                let floor_number = ''
                if(fl!=13){
                    floor_number   = fl>9 ? fl:"0"+fl;
                }else{
                    floor_number   = "12A";
                }

                let start_room     = parseInt(bc.room_start)
                let max_room       = parseInt(bc.max_room_per_floor)
                let result = []
                let tmp = {}
                let pd_code_tmp = ''
                let bef = 0
                let desc_run = 0

                let running = 0
                let non_block = {}

                for (let i = 1; i <= max_room; i++) {
                    if(bc.room_align=='DESC'){
                        if (i > start_room) {
                            if(bef==start_room){
                                desc_run = max_room
                            }

                            pd_code_tmp = bc.bd_name + '-' + floor_number + (desc_run<10 ? '0'+desc_run:desc_run)
                            tmp = this.unit_list ? this.unit_list.filter(unit =>
                                unit.PD_CODE.substring(0, pd_code_tmp.length) === pd_code_tmp
                            ):[]
                            if(tmp&&tmp.length==1){
                                tmp = tmp[0]
                            }

                            result.push(tmp)

                            bef = 0
                            desc_run--
                        } else {

                            pd_code_tmp = bc.bd_name + '-' + floor_number + (i<10 ? '0'+i:i)
                            tmp = this.unit_list ? this.unit_list.filter(unit =>
                                unit.PD_CODE.substring(0, pd_code_tmp.length) === pd_code_tmp
                            ):[]
                            if(tmp&&tmp.length==1){
                                tmp = tmp[0]
                            }

                            result.unshift(tmp)
                            bef++
                        }
                    }else {

                        pd_code_tmp = bc.bd_name + '-' + floor_number + (i<10 ? '0'+i:i)
                        tmp = this.unit_list ? this.unit_list.filter(unit =>
                            unit.PD_CODE.substring(0, pd_code_tmp.length) === pd_code_tmp
                        ):[]
                        if(tmp&&tmp.length==1){
                            tmp = tmp[0]
                        }

                        if(i>=start_room){
                            if (i == start_room) {
                                result.unshift(tmp)
                            }else{
                                bef++
                                result.splice(bef, 0, tmp)
                                result.join()
                            }
                        }else{
                            result.push(tmp)
                        }
                    }
                }

                return result
            },
            getDirectionName(direction_code){
                let direction_name = ''
                if (direction_code == 'N') direction_name = "ทิศเหนือ"
                if (direction_code == 'E') direction_name = "ทิศตะวันออก"
                if (direction_code == 'S') direction_name = "ทิศใต้"
                if (direction_code == 'W') direction_name = "ทิศตะวันตก"
                if (direction_code == 'NW') direction_name = "ทิศตะวันตกเฉียงเหนือ"
                if (direction_code == 'NE') direction_name = "ทิศตะวันออกเฉียงเหนือ"
                if (direction_code == 'SE') direction_name = "ทิศตะวันออกเฉียงใต้"
                if (direction_code == 'SW') direction_name = "ทิศตะวันตกเฉียงใต้"
                return direction_name
            },
            roomDirectionFilter(bd_runno){
                return this.room_direction&&this.room_direction.length>0 ? this.room_direction.filter(item => item.bd_runno === bd_runno):[]
            },
            async getPlanSetting(){
                const requestBody = {
                    pj_code:this.project_code,
                    plan_type:this.plan_type
                }
                let promiseChecking, finalResult = []

                promiseChecking = await this.promiseHandle(this.PostHttp('salePlan/config/getPlanSetting', requestBody,false,'json','rms'))

                if (!promiseChecking.error) {
                    if (promiseChecking.result.status=='success'&&promiseChecking.result.res.data.code == '000') {
                        finalResult = {...promiseChecking.result.res.data.result}
                    }
                }

                return finalResult
            },
            async getBuildingSetting(){
                const requestBody = {
                    pj_code:this.project_code,
                    plan_type:this.plan_type
                }
                let promiseChecking, finalResult = []

                promiseChecking = await this.promiseHandle(this.PostHttp('salePlan/config/getBuildingSetting', requestBody,false,'json','rms'))

                if (!promiseChecking.error) {
                    if (promiseChecking.result.status=='success'&&promiseChecking.result.res.data.code == '000') {
                        finalResult = [...promiseChecking.result.res.data.result]
                    }
                }

                return finalResult
            },
            async getDirectionSetting(){
                const requestBody = {
                    pj_code:this.project_code,
                    plan_type:this.plan_type
                }
                let promiseChecking, finalResult = []

                promiseChecking = await this.promiseHandle(this.PostHttp('salePlan/config/getDirectionSetting', requestBody,false,'json','rms'))

                if (!promiseChecking.error) {
                    if (promiseChecking.result.status=='success'&&promiseChecking.result.res.data.code == '000') {
                        finalResult = [...promiseChecking.result.res.data.result]
                    }
                }

                return finalResult
            },
            async getRmsUnitByProjectCode(){
                const requestBody = {
                    pj_code:this.project_code
                }
                let promiseChecking, finalResult = []

                promiseChecking = await this.promiseHandle(this.PostHttp('salePlan/config/getRmsUnitByProjectCode', requestBody,false,'json','rms'))

                if (!promiseChecking.error) {
                    if (promiseChecking.result.status=='success'&&promiseChecking.result.res.data.code == '000') {
                        finalResult = [...promiseChecking.result.res.data.result]
                    }
                }

                return finalResult
            },
            hideBlankFloor(){

                let elem = this.$el.querySelectorAll("[class='plan-table mt-2']")
                for (let x = 0; x < elem.length; x++) {
                    let table = elem[x]
                    let found_unit = 0
                    let just_remove_rt = []

                    if (table.tagName == 'TABLE') {
                        let i = 0,row
                        for (i; row = table.rows[i]; i++) {

                            if (i > 1) {
                                found_unit = 0;
                                for (let j = 0, col; col = row.cells[j]; j++) {
                                    if(col.classList.contains('has_unit')) {
                                        found_unit++
                                    }
                                }
                                if (found_unit == 0) {
                                    just_remove_rt.push(i)
                                }
                            }
                        }

                        // console.log(just_remove_rt.reverse())

                        let total_tr = i-2
                        let total_hide_tr = 0
                        just_remove_rt.reverse().forEach((data, key) => {
                            if(!this.hideBlank){
                                table.rows[data].classList.remove("d-none");
                                if(data==2){
                                    table.parentElement.classList.remove("d-none");
                                    table.parentElement.previousSibling.classList.remove("d-none");
                                }
                            }else {
                                table.rows[data].classList.add("d-none");
                                total_hide_tr++;
                                if(total_hide_tr==total_tr){
                                    table.parentElement.classList.add("d-none");
                                    table.parentElement.previousSibling.classList.add("d-none");
                                }
                            }
                        });
                    }

                }
            },
            // async renderPlanAsImage(eid){
            //     this.overall_image = ''
            //     //แสดง loading
            //     this.current_loading_state.show = true
            //     store.commit('changeLoadingState', this.current_loading_state)
            //
            //     this.onRenderCanvas = true
            //     this.$el.querySelector("#"+eid).parentNode.style.overflow = 'visible';
            //
            //     await html2canvas(this.$el.querySelector("#"+eid)).then(canvas => {
            //         // console.log(canvas)
            //         this.$el.querySelector("#"+eid).parentNode.style.overflow = 'scroll';
            //         this.overall_image =  canvas.toDataURL()
            //
            //     });
            //
            //     this.overlay2 = true
            //     this.onRenderCanvas = false
            //     //ซ่อน loading
            //     this.current_loading_state.show = false
            //     store.commit('changeLoadingState', this.current_loading_state)
            // }
        }
    }
</script>

<style scoped>
    .plan-table-detail{
        overflow-x: scroll;
        zoom: var(--zoom-amount);
        -webkit-text-size-adjust: auto;
    }
    .plan-table-detail.on-canvas{
        overflow-x: visible !important;
        overflow: visible !important;
    }

    .plan-table{
        border-collapse:separate;
        border-spacing: 5px;
    }
    .plan-table th,td{
        text-align: center;
        padding: 4px;
    }
    .plan-table th{
        border-radius: 3px;
        border: 1px solid #ccc;
        -webkit-text-size-adjust: auto;
    }
    .plan-table td{
        border-radius: 3px;
        border: 1px solid #ccc;
        min-width: 60px;
        width:60px;
        height: 50px;
        -webkit-text-size-adjust: auto;
    }
    .direction{
        background: #5cb2e5;
        color: #ffffff;
    }
    .floor-no{
        background: #fff;
        min-width: 60px !important;
        color: #2489c5;
        position: sticky;
        position: -webkit-sticky;
        left: -1px;
        top: 0;
        z-index: 2;
        -webkit-text-size-adjust: auto;
    }
    .bd-no{
        background: #2489c5;
        color: #fff;
        font-size: 2em;
        font-weight: bold;
        position: sticky;
        position: -webkit-sticky;
        left: -1px;
        top: 0;
        z-index: 2;
        -webkit-text-size-adjust: auto;
    }
    .plan-table th.room-no,td.room-no{
        background: #fff;
        color: #000;
        font-size: 1em;
        /*font-weight: bold;*/
        -webkit-text-size-adjust: auto;
    }
    .with_direction{
        background: #ffffff !important;
    }
    .unit{
        position: relative;
        background: #fff;
        vertical-align: text-top;
        font-size: 0.85em;
        color:#555;
        -webkit-text-size-adjust: auto;
    }

    .unit.has_unit{
        cursor: pointer;
    }

    .unit.has_unit:hover{
        border: 1px solid #cca542;
        box-shadow: 1px 1px 10px #cc8531;
    }

    .unit .unit_code{
        margin: -4px;
        font-size: 0.75em;
        white-space: nowrap;
        /*background-color: #afd6f6;*/
        background-color: #ddd;
        border-bottom: 1px solid #bbb;
        -webkit-text-size-adjust: auto;
    }
    .unit .unit_value{
        margin-top: 4px;
        font-size: 1em;
        -webkit-text-size-adjust: auto;
    }

    .unit .unit_lock{
        width: 100%;
        position: absolute;
        margin: -4px;
        font-size: 1em;
        -webkit-text-size-adjust: auto;
    }
    .unit .unit_lock::before{
        content: "";
        display: flex;
        width: 100%;
        height: 100%;
        position: absolute;
        background-color: black;
        opacity: 0.5;
    }
    .unit .unit_lock::after{
        content: "จองแล้ว";
        display: flex;
        width: 100%;
        justify-content: center;
        align-items: center;
        color: white;
        opacity: 1;
        z-index: 1;
    }

    .no-room{
        border: none !important;
    }

    #overall_plan{
        max-width: 100vw;
        max-height: 100vh;
    }

    .float_zoom_tool{
        position: fixed;
        font-size: 0.85rem;
        color: #00acc1;
        background-color: #ffffff;
        text-shadow: -1px 0 #fff, 0 1px #fff, 1px 0 #fff, 0 -1px #fff;
        border-radius: 5px;
        padding: 2px 5px;
        left: unset !important;
        min-width: 150px;
        right: 10px !important;
        max-height: 35px;
        bottom: var(--bottom-zoom-tool) !important;
        top: unset;
        z-index: 3;
    }

</style>
